import React from 'react';
import PropTypes from 'prop-types';
import BooleanField from 'components/field/BooleanField';
import ComponentToggle from 'components/list/Toggle/ComponentToggle';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import RelativeDateField from 'components/field/RelativeDateField';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import authHelper from 'helpers/auth';
import { LockIcon } from 'assets/materialIcons/materialIcons';
import { deleteApiKey } from 'store/actions/apiKeys/deleteApiKeys';
import { fetchApiKeys } from 'store/actions/apiKeys/fetchApiKeys';

const ApiKeysList = (props) => {
    const {
        actionType,
        location,
        resource,
    } = props;

    const isImpersonated = authHelper.isImpersonated();

    return (
        <div>
            <ResourceList
                action={ fetchApiKeys }
                actionType={ actionType }
                location={ location }
                resource={ resource }
            >
                <Table>
                    <TextField
                        source='name'
                        label='resources.api-keys.fields.name'
                        column={ {
                            link: false,
                            sortable: false,
                            width: '30%',
                        } }
                    />

                    <TextField
                        source='token'
                        label='resources.api-keys.fields.token'
                        column={ {
                            link: false,
                            sortable: false,
                            width: '20%',
                        } }
                    />

                    <TextField
                        source='created_at'
                        label='resources.api-keys.fields.created_at'
                        column={ {
                            link: false,
                            sortable: false,
                            width: '20%',
                        } }
                    />

                    <RelativeDateField
                        source='last_used_at'
                        label='resources.api-keys.fields.last_used_at'
                        column={ {
                            link: false,
                            sortable: false,
                            width: '20%',
                        } }
                    />

                    { isImpersonated ?
                        <DropDownActionsMenu
                            column={ {
                                align: 'center',
                                link: false,
                                width: '10%',
                            } }
                        >
                            <BooleanField
                                sortable={ false }
                                source='is_locked'
                                trueValue={ <LockIcon /> }
                            />
                        </DropDownActionsMenu>
                        :
                        <ComponentToggle
                            validatedSource='is_locked'
                            column={ {
                                align: 'center',
                                link: false,
                                width: '10%',
                            } }
                        >
                            <BooleanField
                                sortable={ false }
                                source='is_locked'
                                trueValue={ <LockIcon /> }
                            />

                            <DropDownActionsMenu>
                                <EditAction />

                                <DeleteAction action={ deleteApiKey } />
                            </DropDownActionsMenu>
                        </ComponentToggle>
                    }
                </Table>
            </ResourceList>
        </div>
    );
};

ApiKeysList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
};

export default ApiKeysList;



// WEBPACK FOOTER //
// ./src/pages/api-keys/list/ApiKeysList.js